import { MoreHorizontal } from 'lucide-react';
import { ActionMenu } from '@/shared/components';

interface Props {
  onNewSubfolder: () => void;
  onRename: () => void;
  onDelete: () => void;
}

/**
 * Kontextmenü eines Custom-Ordners: Neuer Unterordner / Umbenennen / Löschen (§4.2).
 *
 * Der Auslöser war `opacity-0` bis zum Hover — auf dem Telefon ließ sich ein selbst angelegter
 * Ordner damit weder umbenennen noch löschen (§9).
 */
export function AkteFolderMenu({ onNewSubfolder, onRename, onDelete }: Props) {
  return (
    <ActionMenu
      trigger={
        <button
          type="button"
          aria-label="Ordner-Aktionen"
          className="text-ink-faint hover:text-ink flex h-11 w-11 shrink-0 items-center justify-center rounded transition-colors"
        >
          <MoreHorizontal size={16} />
        </button>
      }
      items={[
        { label: 'Neuer Unterordner', icon: 'Plus', onClick: onNewSubfolder },
        { label: 'Umbenennen', icon: 'Edit', onClick: onRename },
        { separator: true },
        { label: 'Löschen', icon: 'Trash', onClick: onDelete, destructive: true },
      ]}
    />
  );
}
